<template>
    <card-carregando v-if="isLoadingComponent" />
    <v-card v-else>
        <v-card-text>
            <v-form ref="form_indicacao_org" v-model="isValid">
                <v-container>
                    <v-card>
                        <v-card-text>
                            <v-layout justify-space-between wrap>
                                <v-flex sm3>
                                    <v-text-field :value="formulario.nu_cpf" label="CPF do indicado"
                                        append-icon="people_outline" disabled />
                                </v-flex>
                                <v-flex sm8>
                                    <v-text-field :value="formulario.no_nome" label="Nome do indicado"
                                        append-icon="people_outline" disabled />
                                </v-flex>
                                <v-flex sm3>
                                    <v-text-field :value="formulario.no_uf" label="UF"
                                        append-icon="place" disabled />
                                </v-flex>
                                <v-flex sm8>
                                    <v-text-field :value="formulario.no_nome_votacao" label="Nome da votação"
                                        append-icon="people_outline" disabled />
                                </v-flex>
                            </v-layout>
                            <v-card>

                                <v-card-title primary-title>
                                    <h3><b>Documentação</b></h3>
                                </v-card-title>
                                <v-layout wrap justify-center>
                                    <v-flex v-for="arquivo in arquivosAvaliacao" :key="arquivo.co_arquivo" sm12>
                                        <v-card>
                                            <v-layout mt-3>
                                                <v-flex sm11 ml-3>
                                                    <h4>
                                                        <b>{{ descricaoArquivos[arquivo.tp_arquivo] }}</b>
                                                    </h4>
                                                </v-flex>
                                                <v-flex sm1 ml-3>
                                                    <v-icon large color="blue darken-4"
                                                        @click="downloadArquivo(arquivo.co_arquivo)">
                                                        cloud_download
                                                    </v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-flex class="pa-1" style="margin-left: 20px">
                                                <v-radio-group v-model="arquivo.st_situacao" row
                                                    :rules="[rules.required]" :disabled="habilitado || formDisabled">
                                                    <v-radio label="Regular" class="v-label" value="REGULAR" />
                                                    <v-radio label="Irregular" class="v-label" value="IRREGULAR" />
                                                </v-radio-group>
                                            </v-flex>
                                            <v-flex v-if="arquivo.st_situacao === 'IRREGULAR'" class="pa-2">
                                                <v-textarea v-model="arquivo.ds_avaliacao" box label="Observação"
                                                    name="input-7-4" rows="5" row-height="20" :counter="500"
                                                    :rules="[rules.tamanhoMaximo500Caracteres]"
                                                    :disabled="habilitado || arquivo.st_situacao == 'REGULAR'  || formDisabled" />
                                            </v-flex>
                                        </v-card>

                                    </v-flex>
                                </v-layout>
                            </v-card>

                        </v-card-text>
                    </v-card>
                    <v-layout class="mt-3" wrap align-center>
                        <v-flex xs12 sm12 lg12>
                            <v-card>
                                <v-card-title color="white darken-3">
                                    <h3><b>Avaliação</b></h3>
                                </v-card-title>
                                <v-layout>
                                    <v-flex class="pa-3">
                                        <v-radio-group column v-model="formulario.st_habilitacao"
                                            :rules="[rules.required]" :disabled="habilitado || formDisabled">
                                            <v-radio value="1" color="success">
                                                <template v-slot:label>
                                                    <div><strong class="success--text">Habilitado</strong></div>
                                                </template>
                                            </v-radio>
                                            <v-radio value="0" color="error">
                                                <template v-slot:label>
                                                    <div><strong class="error--text">Inabilitado</strong></div>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex class="pa-3">
                                        <v-textarea v-model="formulario.ds_parecer" box label="* Parecer"
                                            name="input-7-4" rows="13" row-height="28" :counter="3000"
                                            :rules="[rules.required, rules.tamanhoMaximo3000Caracteres]"
                                            :disabled="habilitado || formDisabled" />
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions v-if="!formDisabled" class="justify-center">
                    <v-btn @click="fecharDialogo">
                        <v-icon left>
                            undo
                        </v-icon>
                        Voltar
                    </v-btn>
                    <v-btn :loading="loading" color="primary" :disabled="!isValid || isLoading || habilitado"
                        @click.native="abrirDialogo">
                        <v-icon left>
                            send
                        </v-icon>
                        Avaliar
                    </v-btn>
                    <v-btn :loading="isLoading" color="primary" v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR
                    && habilitado" @click.native="abrirDialogoEditar">
                        <v-icon left>
                            edit
                        </v-icon>
                        Editar parecer
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card-text>
        <v-layout justify-center>
            <dialog-confirmacao v-model="modalConfirmacao" title="Deseja realmente enviar?"
                text="Os dados enviados não poderão ser alterados posteriormente." cancel-text="Não" confirm-text="Sim"
                :is-loading="isLoading" @dialog-response="respostaDialog" />
        </v-layout>


        <v-layout justify-center>
            <v-dialog
                v-model="modalDialogoEditar"
                max-width="800"
            >
                <v-card>
                    <v-layout
                        wrap
                        align-center
                    >
                    <v-flex>
                            <v-card>
                                <v-card-title color="white darken-3">
                                <h3><b>Documentação</b></h3>
                                </v-card-title>
                                <v-container
                                fluid
                                grid-list-xl
                                >
                                <v-layout
                                    column
                                    wrap
                                    justify-center
                                >
                                    <v-flex
                                    v-for="arquivo in arquivosEdicao"
                                    :key="arquivo.co_arquivo"
                                    md6
                                    >
                                    <v-card
                                    v-if="arquivo.co_arquivo"
                                    min-height="55"
                                    class="elevation-1"
                                    >
                                        <v-layout>
                                        <v-flex
                                            xs10
                                            sm10
                                            md10
                                            lg12
                                        >
                                            <h4 style="margin-left: 20px">
                                            <b>
                                                {{ descricaoArquivos[arquivo.tp_arquivo] }}
                                            </b>
                                            </h4>
                                        </v-flex>
                                        <v-flex
                                            xs3
                                            sm1
                                            mt-2 mr-2
                                        >
                                            <v-icon
                                            large
                                            color="blue darken-4"
                                            @click="downloadArquivo(arquivo.co_arquivo)"
                                            >
                                            cloud_download
                                            </v-icon>
                                        </v-flex>
                                        </v-layout>
                                        <v-flex
                                        class="pa-1"
                                        style="margin-left: 20px"
                                        >
                                        <v-radio-group
                                            v-model="arquivo.st_situacao"
                                            label="*Situação do documento:"
                                            row
                                            :rules="[rules.required]"
                                        >
                                            <v-radio
                                            label="Regular"
                                            class="v-label"
                                            value="REGULAR"
                                            />
                                            <v-radio
                                            label="Irregular"
                                            class="v-label"
                                            value="IRREGULAR"
                                            />
                                        </v-radio-group>
                                        </v-flex>
                                        <v-flex
                                        v-if="arquivo.st_situacao === 'IRREGULAR'"
                                        class="pa-2"
                                        >
                                        <v-textarea
                                            v-model="arquivo.ds_avaliacao"
                                            box
                                            label="Observação"
                                            name="input-7-4"
                                            rows="5"
                                            row-height="20"
                                            :counter="500"
                                            :rules="[rules.tamanhoMaximo500Caracteres]"
                                            :disabled="arquivo.st_situacao == 'REGULAR'"
                                        />
                                        </v-flex>
                                    </v-card>
                                    </v-flex>
                                </v-layout>
                                </v-container>
                            </v-card>
                            </v-flex>

                        <v-flex
                            xs12
                            sm12
                            class="ma-3"
                        >
                        <div class="ma-4 text-justify subheading grey--text">
                            <b>Parecer:</b>
                        </div>
                        <v-textarea
                            v-model="formularioEditado.ds_parecer"
                            name="input-7-1"
                            box
                            solo
                            label="Parecer da Habilitação"
                            auto-grow
                            :placeholder="'Digite seu parecer aqui.'"
                            :counter="3000"
                            :rules="[rules.required, rules.tamanhoMaximo3000Caracteres]"
                            required
                        />
                        </v-flex>
                    </v-layout>
                    <v-layout
                        wrap
                        align-center
                    >
                        <v-flex
                        xs12
                        sm12
                        class="ma-3"
                        >
                        <div class="ma-4 text-justify subheading grey--text">
                            <b>Justificativa da edição:</b>
                        </div>
                        <v-textarea
                            v-model="formularioEditado.ds_edicao_justificativa"
                            name="input-7-1"
                            box
                            solo
                            label="Justificativa da edição da Habilitação"
                            auto-grow
                            :placeholder="'Digite sua justificativa de edição da habilitação aqui.'"
                            :counter="3000"
                            :rules="[rules.required, rules.tamanhoMaximo3000Caracteres]"
                            required
                        />
                        </v-flex>

                        <v-flex class="mx-3 pa-3">
                            <v-radio-group column v-model="formularioEditado.st_habilitacao"
                                :rules="[rules.required]">
                                <v-radio value="1" color="success">
                                    <template v-slot:label>
                                        <div><strong class="success--text">Habilitado</strong></div>
                                    </template>
                                </v-radio>
                                <v-radio value="0" color="error">
                                    <template v-slot:label>
                                        <div><strong class="error--text">Inabilitado</strong></div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        wrap
                        align-center
                    >
                    </v-layout>
                        <v-card-actions v-if="!isLoading">
                            <v-spacer />
                            <v-btn
                            color="red darken-1"
                            text
                            flat
                            @click="fecharDialogoEditar"
                            >
                            Cancelar
                            </v-btn>
                            <v-btn
                            color="green darken-1"
                            text
                            flat
                            :disabled="!formularioEditado.ds_edicao_justificativa"
                            @click="editar"
                            >
                            Editar
                            </v-btn>
                        </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import codigosPerfil from '@/modules/conta/utils/codigosPerfil'
import CardCarregando from '@/modules/shared/components/CardCarregando';
import DialogConfirmacao from '@/modules/shared/components/DialogConfirmacao'

export default {
    name: 'IndicacaoConselhoHabilitacaoComponent',
    components: {
        CardCarregando,
        DialogConfirmacao
    },
    props: {
        coConselho: {
            type: Number,
            default: 0,
        },
        indicado: {
            type: Object,
            default: () => { }
        },
        isLoadingComponent: {
            type: Boolean,
            default: false
        },
        loadingIs: {
            type: Boolean,
            default: false
        },
        formDisabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            codigosPerfil,
            habilitado:false,
            isValid: false,
            loading: false,
            isLoading: false,
            modalConfirmacao: false,
            modalDialogoEditar: false,
            formulario: {
                nu_cpf: '',
                no_nome: '',
            },
            formularioEditado: {
                nu_cpf: '',
                no_nome: '',
            },
            arquivosAvaliacao: [],
            arquivosEdicao: [],
            descricaoArquivos: {
                foto_indicado: 'Foto de rosto*',
                curriculo_indicado: 'Currículo*',
                curriculo_resumido_indicado: 'Currículo resumido para a candidatura*',
                portifolio_indicado: 'Portifólio*',
                cmpr_atuacao: 'Comprovação, por meio de portaria de designação ou termo de posse, de atuação em instâncias colegiadas nos últimos 10 anos, se houver',
                cpf_indicado: 'Cópia do documento de identificação (conforme item 2.8 deste edital) e CPF*',
                cmpres_indicado: 'Comprovante de residência com o nome do indicado ou declaração de residência (ANEXO 6)*',
                autorizacao_indicado: 'Declaração que autoriza a Secretaria Especial da Cultura do Ministério do Turismo a divulgar as imagens e informações contidas na inscrição e que responsabiliza o candidato pelos documentos e materiais apresentados (ANEXO 2 do edital)*',
                declaracao_indicado: 'Declaração do indicado de que possui disponibilidade para compor o Conselho Nacional de Política Cultural - CNPC, no triênio 2022/2025 (ANEXO 2 do edital)*',
                delico_indicado: 'Documento que comprove a deliberação do Conselho, presencial ou virtual, para indicação dos candidatos*',
                termo_indicacao: 'Termo de indicação de representante do Conselho de Cultura assinado pelo presidente do conselho (ANEXO 5)*',
            },
            rules: {
                required: value => !!value || 'Este campo é obrigatório',
                habilitada: value => value != '-1' || 'Este campo é obrigatório',
                minCaracter: value => value.length >= 8 || 'Mínimo 8 caracteres',
                tamanhoMaximo500Caracteres: value => (!!value && value.length <= 500) || 'Máximo 500 caracteres',
                tamanhoMaximo3000Caracteres: value => (!!value && value.length <= 3000) || 'Máximo 3000 caracteres',
            },
        }
    },
    computed: {
        ...mapGetters({
            indicadosConselho: 'conselho/indicadosConselho',
            perfil: 'conta/perfil',
        }),
    },
    watch: {
        isLoadingComponent: {
            immediate: true,
            deep:true,
            handler(valor) {
                this.formulario = {
                    nu_cpf: '',
                    no_nome: '',
                };
                this.arquivosAvaliacao = [];
                if (!valor) {
                    if (this.indicado) {
                        this.formulario = Object.assign({}, this.indicado);
                        this.formulario.ds_edicao_justificativa = null;
                        this.habilitado = this.indicado.st_habilitacao !== '-1'
                 
                        this.indicado.arquivos.forEach(item => {
                            this.arquivosAvaliacao.push({
                                co_arquivo: item.arquivo.co_arquivo,
                                co_situacao_arquivo: item.arquivo.situacaoArquivo.co_situacao_arquivo,
                                st_situacao: item.arquivo.situacaoArquivo.st_situacao,
                                ds_avaliacao: item.arquivo.situacaoArquivo.ds_avaliacao,
                                tp_arquivo: item.tp_arquivo,
                            });
                        });
                    }
                }
            }

        }
    },
    methods: {
        ...mapActions({
            downloadArquivo: 'shared/downloadArquivo',
            avaliarIndicacao: 'conselho/avaliarIndicacao'
        }),
        abrirDialogo() {
            if (!this.$refs.form_indicacao_org.validate()) {
                return false;
            }
            this.modalConfirmacao = true;
            return true;
        },
        abrirDialogoEditar() {
            this.formularioEditado.ds_parecer = this.formulario.ds_parecer;
            this.formularioEditado.st_habilitacao = this.formulario.st_habilitacao;
            this.arquivosEdicao = this.arquivosAvaliacao;
            this.modalDialogoEditar = true;
            return true;
        },
        fecharDialogo() {
            this.$emit('fechar')
        },
        fecharDialogoEditar() {
            this.formularioEditado = {};
            this.arquivosEdicao = this.arquivosAvaliacao;
            this.modalDialogoEditar = false;
        },
        respostaDialog(tipoResposta) {
            if (tipoResposta) {
                this.salvar();
            } else {
                this.modalConfirmacao = false;
            }
        },
        salvar(){
            if(!this.$refs.form_indicacao_org.validate()){
                return false;
            }

            this.isLoading = true;
            const indicacaoConselhoToSave = {
                co_indicado_conselho: this.formulario.co_indicado_conselho,
                ds_parecer: this.formulario.ds_parecer,
                st_habilitacao: this.formulario.st_habilitacao,
                ds_edicao_justificativa: this.formulario.ds_edicao_justificativa,
                arquivos: this.arquivosAvaliacao,
            };
            this.avaliarIndicacao(indicacaoConselhoToSave).then(()=>{
                this.$emit('salvo');
            }).finally(() => {
                this.isLoading = false;
                this.modalConfirmacao = false;
                this.modalDialogoEditar = false;
            });
        },
        editar() {
            this.formularioEditado.ds_edicao_justificativa = this.formularioEditado.ds_edicao_justificativa.trim();
            if (!this.formularioEditado.ds_edicao_justificativa) {
                return;
            }
            Object.assign(this.formulario, this.formularioEditado);
            Object.assign(this.arquivosAvaliacao, this.arquivosEdicao);
            this.abrirDialogo();
        },
    }
}
</script>